export default {
  Comet: 'Comet',
};
